import { EchartsWithTheme, useTheme } from '@maxtropy/components';
import { apiV2OperationAnalysisDemandPost } from '@maxtropy/dmes-apis-v2';
import { useRequest } from 'ahooks';
import { useMemo, useState } from 'react';
import { getDemandOption } from '../../chartOptions';
import { formatValue } from '../../utils';
import AnalysisToolbar, { AnalysisFilterValue } from '../AnalysisToolbar';
import SectionHeader from '../SectionHeader';
import styles from './index.module.scss';

const exportDemand = ({ range }: AnalysisFilterValue) => {
  const query = new URLSearchParams({
    timestamp: String(Date.now()),
    startDate: range[0].format('YYYY-MM'),
    endDate: range[1].format('YYYY-MM'),
  });
  window.open(`/api/v2/operation-analysis/demand/export?${query.toString()}`, '_blank');
};

const DemandAnalysis = () => {
  const theme = useTheme();
  const [filter, setFilter] = useState<AnalysisFilterValue>();
  const { data } = useRequest(
    () => {
      const currentFilter = filter!;
      return apiV2OperationAnalysisDemandPost({
        timestamp: Date.now(),
        startDate: currentFilter.range[0].format('YYYY-MM'),
        endDate: currentFilter.range[1].format('YYYY-MM'),
      });
    },
    {
      ready: !!filter,
      refreshDeps: [filter],
    }
  );
  const baselineData = data?.baselineData;
  const actualData = data?.actualData;
  const chartOption = useMemo(
    () => getDemandOption(data?.trendData ?? [], baselineData?.monthlyAverageDemand),
    [baselineData?.monthlyAverageDemand, data?.trendData]
  );

  return (
    <section className={styles.section}>
      <SectionHeader title="需量分析" />
      <AnalysisToolbar showGranularity={false} enforceRangeRules onChange={setFilter} onExport={exportDemand} />
      <div className={styles.summaryGrid}>
        <div className={styles.summaryCard}>
          <span>基准数据 (2025-01~2025-12)</span>
          <div>
            <p>
              月均需量<strong>{formatValue(baselineData?.monthlyAverageDemand, 'MW')}</strong>
            </p>
            <p>
              总需量(检修月除外)
              <strong>{formatValue(baselineData?.totalDemandExcludingMaintenance, 'MW')}</strong>
            </p>
          </div>
        </div>
        <div className={styles.summaryCard}>
          <span>实际运行</span>
          <div>
            <p>
              月均需量<strong>{formatValue(actualData?.monthlyAverageDemand, 'MW')}</strong>
            </p>
            <p>
              总需量(检修月除外)
              <strong>{formatValue(actualData?.totalDemandExcludingMaintenance, 'MW')}</strong>
            </p>
          </div>
        </div>
      </div>
      <EchartsWithTheme theme={theme} option={chartOption} style={{ height: 280, marginTop: 16 }} />
    </section>
  );
};

export default DemandAnalysis;
